export default {
    StockStructureConfiguration: {
        Header: {
          Name: '仓库结构配置名称',
          Status: '仓库结构配置状态',
          Create: '创建',
          Action: '结构配置',
          Cancel: '下架',
          Publish: '发布',
        },
        table: {
          Code: '仓库结构配置编码',
          Name: '仓库结构配置名称',
          status: '仓库结构配置状态',
          Release: '发布状态',
          by: '创建人',
          time: '创建时间',
          Action: '操作'
        },
        Form: {
          Create: '创建仓库结构配置',
          Code: '仓库结构配置编码',
          Name: '仓库结构配置名称',
          pps: '系统自动生成',
          ps: '请输入仓库结构配置名称',
        }
    }
};
